import { atom } from "recoil";
import { defaultConfig, WebUIConfig } from "@terragotech/gen5-shared-components";
import { logOnSet } from "../effects";

export const configState = atom<WebUIConfig>({
  key: 'config.config',
  default: defaultConfig,
  effects: [logOnSet],
});
